import styled, { css } from 'styled-components';
import { Stack, StoreLogo, Typography } from '@karma/components';
import { getColor } from '@karma/components/colors';

export const HoverContainer = styled(Stack)`
  visibility: hidden;
  z-index: -1;
  position: absolute;
  width: 100%;
  height: 100%;
  background: ${getColor('neutral5')};
  padding: 8px;

  & > * {
    min-width: 92px;
    padding-right: 10px;
    padding-left: 10px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  overflow: hidden;
  border-radius: 10px;
  position: relative;
  background: ${getColor('neutral5')};

  ${({ $height }) =>
    $height &&
    css`
      height: ${$height}px;
    `};

  &:hover {
    ${HoverContainer} {
      visibility: visible;
      z-index: 10;
    }
  }
`;

export const CardContent = styled(Stack)`
  padding: 0 8px;
`;

export const Name = styled(Typography)`
  -webkit-line-clamp: ${({ isNameMultipleWords }) => (isNameMultipleWords ? 2 : 1)};
  display: ${({ isNameMultipleWords }) => (isNameMultipleWords ? '-webkit-box' : 'block')};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  white-space: pre-line;
  word-break: break-word;

  ${({ direction }) =>
    direction === 'column' &&
    css`
      max-width: calc(100% - 20px);
      margin-top: 65px;
    `}
`;

export const StyledStoreLogo = styled(StoreLogo)`
  ${({ direction }) =>
    direction === 'column' &&
    css`
      position: absolute;
      top: 30px;
    `}
`;
